export default "__VITE_ASSET__583998b4__"